import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSignal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 14 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 30.6H10.2V41.1H6V30.6ZM14.4 24.3H18.6V41.1H14.4V24.3ZM22.8 18H27V29.55V41.1H22.8V18Z",
		fill: "black"
	})
});
export default SvgSignal;
